<template>
    <div class="mt-3" v-if="vmAccount">
        <div class="font-weight-medium mr-2 ml-2">Approved Status:</div>
        <div class="mb-2 ml-2">
            {{ vmAccount.approvedStatusY }}
        </div>
        <v-layout row class="mb-2 mx-2" v-if="allowDownloadCards()">
            <v-btn class="mr-1" color="success" small @click="printCards"
                >Print Cards</v-btn
            >
            <v-btn class="" color="success" small @click="emailCards"
                >Email Cards</v-btn
            >
        </v-layout>

        <div class="title mb-3 pb-3 ml-2">Card Logs</div>
        <div v-for="(log, index) in printCardLogs">
            <v-layout class="mx-2 mb-1" row>
                <div class="width-200">{{ log.cardPrintDate | time }}</div>
                <div class="width-150">{{ log.actionType }}</div>
                <div class="width-200">
                    <span v-if="log.byUser" class="mr-2">User:</span
                    >{{ log.byUser }}
                </div> </v-layout
            ><v-divider
                class="pb-3"
                v-if="index + 1 < printCardLogs.length"
            ></v-divider>
        </div>

        <v-dialog v-model="emailCardsDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Email Cards</v-card-title>
                <v-text-field
                    class="px-3"
                    ref="email"
                    v-model="emailAddress"
                    :rules="emailRules"
                ></v-text-field>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="emailCardsDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="emailing"
                        color="success"
                        @click="sendEmail"
                    >
                        Send
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { getDomain } from "../../utils/helpers.js";
import moment from "moment";

export default {
    props: {
        account: Object,
    },
    data() {
        return {
            emailCardsDialog: false,
            emailAddress: "",
            emailing: false,
            vmAccount: {},
            printCardLogs: [],

            emailRules: [
                (value) => !!value || "Required.",
                (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Invalid e-mail.";
                },
            ],
        };
    },
    async created() {
        const response = await this.$http.get(
            "api/vmAccountStatus/GetByAccountID?accountID=" +
                this.account.accountID
        );

        this.vmAccount = response;

        this.loadLogs();
    },
    computed: {},
    methods: {
        async loadLogs() {
            this.printCardLogs = await this.$http.get(
                "api/vmAccountStatus/GetVmPrintCards?accountID=" +
                    this.account.accountID
            );
        },
        allowDownloadCards() {
            return (
                this.vmAccount.approvedStatus &&
                this.vmAccount.approvedStatus.startsWith("Approved")
            );
        },
        printCards() {
            window.location =
                getDomain() +
                "/api/vmAccountStatus/downloadVmCards?accountID=" +
                this.account.accountID +
                "&user=" +
                this.$store.state.authentication.user;

            this.loadLogs();
        },
        emailCards() {
            this.emailAddress = this.account.emailAddress;

            this.emailCardsDialog = true;
        },
        async sendEmail() {
            if (!this.$refs.email.validate()) return;

            try {
                this.emailing = true;

                await this.$http.post(
                    "api/vmAccountStatus/emailCards?accountID=" +
                        this.account.accountID +
                        "&emailAddress=" +
                        this.emailAddress +
                        "&user=" +
                        this.$store.state.authentication.user
                );

                this.$notify({
                    text: "Email Sent",
                    group: "notification",
                    type: "success",
                });

                this.emailing = false;

                this.emailCardsDialog = false;
                this.emailAddress = this.vmAccount.emailAddress;
                this.loadLogs();
            } catch (e) {
                this.emailing = false;
            }
        },
    },
};
</script>
<style>
.card-width {
    max-width: 65%;
}
</style>
